import script from "./AlertModule.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertModule.vue?vue&type=script&setup=true&lang=js"

import "./AlertModule.vue?vue&type=style&index=0&id=11ecf15b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11ecf15b"]])

export default __exports__